import React from 'react';
import styles from './DashboardCard.module.scss';

const DashboardCard = ({
    cardValue,
    cardDescription,
    cardValueBackgroundColor,
    cardDescriptionBackgroundColor,
    children,
}) => {
    return (
        <>
            <div className={styles.cardContainer}>
                <div
                    className={styles.cardValue}
                    style={{
                        backgroundColor: cardValueBackgroundColor
                            ? cardValueBackgroundColor
                            : '#ececec',
                    }}
                >
                    {children ? children : cardValue || 0}
                </div>
                <div
                    className={styles.cardDescription}
                    style={{
                        backgroundColor: cardDescriptionBackgroundColor
                            ? cardDescriptionBackgroundColor
                            : '#fff',
                    }}
                >
                    {cardDescription}
                </div>
            </div>
        </>
    );
};

export default DashboardCard;
